import { takeLatest, put, select } from 'redux-saga/effects';
import { actions as listActions } from '../slices/RouteStopListSlice';
import { actions } from '../slices/RouteStopSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';

const getSearchCriteria = state => state.routeStopList.searchCriteria;

function* getRouteStopList({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_stops')}`, {
            params: {
                page: page ? page - 1 : null,
                size: limit,
                ...filters,
            }
        });
        yield put({ type: listActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}



function* createRouteStop({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_stops')}`, {
            ...params
        });
        yield put({ type: actions.create_route_stop_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.create_route_stop_failed.type, payload: error });
    }
}

function* updateRouteStop({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_stops')}/${params.id}`, {
            ...params
        });
        yield put({ type: actions.create_route_stop_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        // yield put({ type: listActions.reset_data.type });
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.create_route_stop_failed.type, payload: error });
    }
}

function* deleteRouteStop({ payload: { id } }) {
    try {
        const response = yield NetworkHandler.delete(`${config.getUrl('bus_stops')}/${id}`);
        yield put({ type: actions.delete_route_stop_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Xoá thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.delete_route_stop_failed.type, payload: error });
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getRouteStopList);
    yield takeLatest(actions.create_route_stop.type, createRouteStop);
    yield takeLatest(actions.update_route_stop.type, updateRouteStop);
    yield takeLatest(actions.delete_route_stop.type, deleteRouteStop);
}

export default watchRequestDetail;